module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"desc":"Что произошло","date":"Когда","user":"Инициатор"}}')
  delete Component.options._Ctor
}
